import { create } from 'zustand';
import type { CandidateDetails } from '@/services/api/authApi';

/**
 * App-wide state shown in the header — mirrors Flutter AppStateNotifier
 * (changeJobCount → saved-jobs badge, setCandidateDetails → header name).
 */
interface AppState {
  savedJobsCount: number;
  candidateDetails: CandidateDetails | null;
  setSavedJobsCount: (count: number) => void;
  setCandidateDetails: (details: CandidateDetails | null) => void;
}

export const useAppStateStore = create<AppState>((set) => ({
  savedJobsCount: 0,
  candidateDetails: null,
  setSavedJobsCount: (savedJobsCount) => set({ savedJobsCount }),
  setCandidateDetails: (candidateDetails) => set({ candidateDetails }),
}));
